export const insurersQueryKeys = {
	all: ["insurers"] as const,
	list: () => [...insurersQueryKeys.all, "list"] as const,
};
